export default __webpack_public_path__ + "static/media/activity.f7818f64.svg";